import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import "./styles/globals.css"
// App-wide design tokens (AITS-485). Was only reaching the bundle as a side
// effect of VbLayout being imported in App.tsx; loaded explicitly now that
// globals.css aliases the shadcn variables onto these tokens.
import "./styles/vb.css"
import { AuthProvider } from "./context/AuthContext"
import { Toaster } from "sonner"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import {initPosthog} from "@/lib/posthog.ts";
import { WorkspaceProvider } from "@/context/WorkspaceContext";

initPosthog()

// Module scope, not inside the component: a component body re-runs on every
// render, and a fresh QueryClient is a fresh (empty) cache.
const queryClient = new QueryClient()

const AnswerRank = () => {
    return (
        <AuthProvider>
            <QueryClientProvider client={queryClient}>
                <WorkspaceProvider>
                    <App />
                    <Toaster />
                </WorkspaceProvider>
            </QueryClientProvider>
        </AuthProvider>
    )
}

ReactDOM.createRoot(document.getElementById("root")!).render(<AnswerRank />)
